import * as analytics from 'analytics/Analytics';
import {getWorklistOrFolderAction} from 'bulk-workflows/assembly/BulkAssemblyActions';
import {MOLBIO_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {BulkCodonOptimizationOptions} from 'molbio/codon-optimization/BulkCodonOptimizationModal';
import * as CodonOptimizationDAO from 'molbio/dao/CodonOptimizationDAO';
import * as TrayTaskActions from 'tray/TrayTaskActions';
import * as TrayTaskConstants from 'tray/TrayTaskConstants';
import * as net from 'util/Net';
import {updateWorklists} from 'worklists/WorklistActions';

export async function bulkBackTranslateOrCodonOptimize(
  entityIds: Array<string>,
  parameters: BulkCodonOptimizationOptions,
  isBackTranslation: boolean
): Promise<void> {
  const taskId = TrayTaskActions.createTrayTask({
    heading: isBackTranslation ? 'Back translating proteins' : 'Codon optimizing sequences',
    progress: TrayTaskConstants.INDETERMINATE_PROGRESS,
  });
  try {
    const {worklistSummary} = await CodonOptimizationDAO.bulkBackTranslateOrCodonOptimize(
      entityIds,
      parameters,
      isBackTranslation
    );
    if (isBackTranslation) {
      analytics.deprecatedTrackEvent(MOLBIO_ANALYTICS_ACTIONS.PERFORMED_BULK_BACK_TRANSLATION, {
        type: 'success',
        numAaSequences: entityIds.length,
        ...parameters,
      });
    } else {
      analytics.deprecatedTrackEvent(MOLBIO_ANALYTICS_ACTIONS.PERFORMED_BULK_CODON_OPTIMIZATION, {
        type: 'success',
        numSequences: entityIds.length,
        ...parameters,
      });
    }
    if (worklistSummary) {
      updateWorklists({[worklistSummary.id]: worklistSummary});
    }
    TrayTaskActions.updateTrayTask(taskId, {
      progress: TrayTaskConstants.SUCCESS_PROGRESS,
      heading: 'Saved codon-optimized sequences',
      actions: [getWorklistOrFolderAction(worklistSummary, parameters.sequencesFolderId)],
    });
  } catch (e) {
    if (isBackTranslation) {
      analytics.deprecatedTrackEvent(MOLBIO_ANALYTICS_ACTIONS.PERFORMED_BULK_BACK_TRANSLATION, {
        type: 'failure',
        numAaSequences: entityIds.length,
        ...parameters,
      });
    } else {
      analytics.deprecatedTrackEvent(MOLBIO_ANALYTICS_ACTIONS.PERFORMED_BULK_CODON_OPTIMIZATION, {
        type: 'failure',
        numSequences: entityIds.length,
        ...parameters,
      });
    }
    if (e.responseJSON && e.responseJSON.userMessage) {
      TrayTaskActions.updateTrayTask(taskId, {
        progress: TrayTaskConstants.FAILURE_PROGRESS,
        error: e.responseJSON.userMessage,
      });
    } else if (net.isServerRequestError(e)) {
      TrayTaskActions.updateTrayTask(taskId, {
        progress: TrayTaskConstants.FAILURE_PROGRESS,
        error: e.responseText,
      });
    } else {
      TrayTaskActions.removeTrayTask(taskId);
      throw e;
    }
  }
}
